import { Component, inject, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import { GuruEntity } from '../../../model/guru-entity';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { ModelService } from '../../../services/model-service';
import { SelectionUtils } from '../../selection-utils';

import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-enviro-kit-mechanical-options',
  imports: [MatIcon, FormsModule],
  templateUrl: './enviro-kit-mechanical-options.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './enviro-kit-mechanical-options.component.css'
})
export class EnviroKitMechanicalOptionsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  returnAirSelection!: GuruEntity;
  outsideAirSelection!: GuruEntity;
  outsideAirLocationSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.MECHANICAL_CONNECTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.returnAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRetAirBlockoff');
    this.outsideAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAir');
    this.outsideAirLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAirLocation');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
    entity.Value = newValue;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
